import AcceptIcon from "../../Assets/images/accept.svg";
import RejectIcon from "../../Assets/images/reject.svg";

// Green check / red X for a boolean, the accept/reject pair Pages/TimeClock/ApproveTimesheet already uses.
const LoveForwardCheck = ({ value }) => (
  <img src={value ? AcceptIcon : RejectIcon} alt={value ? "Yes" : "No"} />
);

export default LoveForwardCheck;
